<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('orf-to-jpg-converter', 'Olympus ORF → JPG');

function handleBatchCreated(batchId: string) { console.log('[ORF to JPG] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[ORF to JPG] Job completed:', jobId); }
function handleBatchCleared() { console.log('[ORF to JPG] Batch cleared'); }
function handleError(error: Error) { console.error('[ORF to JPG] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[ORF to JPG] Credits updated:', credits); }
</script>
